//#region src/activeApp.ts
var e = null;
function t(t) {
	e = t;
}
function n() {
	return e;
}
//#endregion
export { n as getActiveApp, t as setActiveApp };
